export default function initLogoCarousel() {
    // ==========================================================
    // LOGO CAROUSEL
    // ==========================================================

    const logoCarousels = document.querySelectorAll("[data-logo-carousel]");

    logoCarousels.forEach((carousel) => {
        const slides = Array.from(carousel.querySelectorAll("[data-logo-slide]"));

        const prevButton = carousel.querySelector(".logo-carousel__arrow--prev");

        const nextButton = carousel.querySelector(".logo-carousel__arrow--next");

        if (!slides.length) {
            return;
        }

        let activeIndex = Math.floor(slides.length / 2);

        let autoplayInterval = null;

        const AUTOPLAY_DELAY = 2500;

        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        // ==========================================================
        // HELPERS
        // ==========================================================

        const getCircularIndex = (index) => {
            return (index + slides.length) % slides.length;
        };

        const renderCarousel = () => {
            const prevIndex = getCircularIndex(activeIndex - 1);
            const prevFarIndex = getCircularIndex(activeIndex - 2);

            const nextIndex = getCircularIndex(activeIndex + 1);
            const nextFarIndex = getCircularIndex(activeIndex + 2);

            slides.forEach((slide, index) => {
                slide.classList.remove("is-active", "is-prev", "is-next", "is-prev-far", "is-next-far", "is-hidden");

                if (index === activeIndex) {
                    slide.classList.add("is-active");
                    return;
                }

                if (index === prevIndex) {
                    slide.classList.add("is-prev");
                    return;
                }

                if (index === nextIndex) {
                    slide.classList.add("is-next");
                    return;
                }

                if (index === prevFarIndex) {
                    slide.classList.add("is-prev-far");
                    return;
                }

                if (index === nextFarIndex) {
                    slide.classList.add("is-next-far");
                    return;
                }

                slide.classList.add("is-hidden");
            });
        };

        // ==========================================================
        // NAVIGATION
        // ==========================================================

        const goToPrev = () => {
            activeIndex = getCircularIndex(activeIndex - 1);

            renderCarousel();
        };

        const goToNext = () => {
            activeIndex = getCircularIndex(activeIndex + 1);

            renderCarousel();
        };

        // ==========================================================
        // AUTOPLAY
        // ==========================================================

        const stopAutoplay = () => {
            if (!autoplayInterval) {
                return;
            }

            window.clearInterval(autoplayInterval);

            autoplayInterval = null;
        };

        const startAutoplay = () => {
            stopAutoplay();

            if (slides.length <= 1 || reducedMotion.matches || document.hidden) {
                return;
            }

            autoplayInterval = window.setInterval(() => {
                goToNext();
            }, AUTOPLAY_DELAY);
        };

        const restartAutoplay = () => {
            stopAutoplay();
            startAutoplay();
        };

        // ==========================================================
        // PREV
        // ==========================================================

        prevButton?.addEventListener("click", () => {
            goToPrev();

            restartAutoplay();
        });

        // ==========================================================
        // NEXT
        // ==========================================================

        nextButton?.addEventListener("click", () => {
            goToNext();

            restartAutoplay();
        });

        // ==========================================================
        // CLICK ON CARD
        // ==========================================================

        slides.forEach((slide, index) => {
            slide.addEventListener("click", () => {
                if (index === activeIndex) {
                    return;
                }

                activeIndex = index;

                renderCarousel();

                restartAutoplay();
            });
        });

        // ==========================================================
        // HOVER
        // ==========================================================

        carousel.addEventListener("mouseenter", () => {
            stopAutoplay();
        });

        carousel.addEventListener("mouseleave", () => {
            startAutoplay();
        });

        // ==========================================================
        // VISIBILITY
        // ==========================================================

        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                stopAutoplay();
                return;
            }

            startAutoplay();
        });

        // ==========================================================
        // REDUCED MOTION
        // ==========================================================

        reducedMotion.addEventListener?.("change", () => {
            if (reducedMotion.matches) {
                stopAutoplay();
                return;
            }

            startAutoplay();
        });

        // ==========================================================
        // INIT
        // ==========================================================

        renderCarousel();

        startAutoplay();
    });
}
